import * as React from 'react';
import { TData, ISelectFieldValue, TDataValue } from '../../components/Table/VirtualizedTableInterfaces';
import { formatDate, SYSTEM_USER } from '../../components/Table/dataHandler/Utils';
import DataAdapterModeltypeBasic from './DataAdapterModeltypeBasic';
import * as _ from "lodash";
import { Column } from 'react-data-grid';
import { DropdownItemProps, FlagNameValues } from 'semantic-ui-react';
import { ITranslatedComponent } from '../../redux/reducers/generalReducer';
import { translate } from 'react-i18next';
import ModelTypeBasicTable from "./ModelTypeBasicTable";
import { getColumns } from "./ModeltypeBasicColumns";
import {OSPGenerationDto} from 'src/services/Client';

interface ModelTypeBasicTableProps {
    data: DataAdapterModeltypeBasic[];
    columns: Column[];
    readonly: boolean;
    onChange: (key: string, data: TDataValue, index: number) => void;
    onChangeSelect: (index: number[]) => void;
    isAdmin:boolean;
    allOSP:OSPGenerationDto[];
}

interface ModelTypeBasicTableState {
}
interface IDataSource { name: string; objectId: number; typefamily: string; }

class ModelTypeTableContainer extends React.Component<ModelTypeBasicTableProps & ITranslatedComponent, ModelTypeBasicTableState> {
    constructor(props: ModelTypeBasicTableProps & ITranslatedComponent) {
        super(props);
        this.state = {
        };
    }

    private buildData(data: DataAdapterModeltypeBasic[]): any[] {
        const typefamilyColumn: { dataSource: IDataSource[] } = _.find(this.props.columns, (item: Column) => item.key === "typefamily") as any;
        const options = _.map(typefamilyColumn.dataSource, (item) => ({ value: item.objectId, text: item.name } as DropdownItemProps));
        const tableData = _.map(data, (item) => {
            return {
                btyp: (item.btyp as string),
                name: this.extractMultiFields(item, "name"),
                typefamily: { value: item.typefamily.objectId, options, extra: typefamilyColumn.dataSource, typefamilyName: item.typefamily.name } as ISelectFieldValue,
                intSequence: item.intSequence,
                color: item.color,
                pdipFlag: item.pdipFlag,
                rowClass: item.pdipFlag ? '' : 'table-invalid-pdip-row',
                changedBy: item.changedBy === SYSTEM_USER ? this.props.t("GLOBAL:SYSTEM_USER") : item.changedBy,
                changedTimestamp: item.changedTimestamp ? formatDate(item.changedTimestamp) : undefined,
                textExportDate: item.textExportDate ,
                textExportStatus: item.textExportStatus,
                pccdFlag: item.pccdFlag,
                visible: item.visible,
                generation:item.generation
            };
        });

        return tableData;
    }

    private extractMultiFields(item: DataAdapterModeltypeBasic, propKey: keyof DataAdapterModeltypeBasic): {} {
        return item[propKey.toString()].map((value: any) => {
            return {
                flag: value.flag as FlagNameValues,
                value: value.text,
                originalValues: value,
            };
        });
    }

    public render() {
        return (
            <ModelTypeBasicTable
                onChangeSelect={this.props.onChangeSelect}
                columnsData={getColumns(this.props.t, this.props.readonly,this.props.isAdmin)}
                data={this.buildData(this.props.data)}
                onChange={this.props.onChange}
                allOSP={this.props.allOSP}
            />
        );
    }
}
export default translate("MT_BASIC_VIEW")(ModelTypeTableContainer);



// WEBPACK FOOTER //
// ./src/views/ModeltypeBasicView/ModelTypeTableContainer.tsx